<template>
    <div class="contact">
        <title-header title="Contato" class="mt-16"/>
        <div class="content">
            <div class="formulario">
                <form>
                    <input type="text" placeholder="NOME" v-model="userContato.nome" name="nome">
                    <input type="email" placeholder="E-MAIL" v-model="userContato.email" name="email">
                    <textarea placeholder="MENSAGEM" v-model="userContato.mensagem" name="msg"/>
                    <button type="submit" @click.prevent="submit">Enviar</button>
                </form>
            </div>
            <div class="info">
                <img class="logo" src="../../../../img/logo/ugt_logo.png">
                <div class="informations">
                    <p>
                        União Geral dos Trabalhadores<br>
                        do Estado de São Paulo - UGT-SP
                    </p>
                    <address>
                        <strong>Sede Tupã</strong><br/>
                        Rua Guaianazes, 596 - Sala UGT - Centro<br/>
                        CEP: 17601-130 - Tupã - SP
                    </address>
                    <address>
                        <strong>Sede da Capital</strong><br/>
                        Rua dos Pinheiros, 20 - 6º andar - Pinheiros<br/>
                        CEP: 05422-000 - São Paulo - SP
                    </address>
                    <address>
                        <strong>Telefones</strong><br>
                        (11) 99492-6889 (Sede São Paulo - Capital)<br>
                        (11) 4801-6920 (Sede São Paulo - Capital) <br/>
                        (14) 99116-2465 (Sede Tupã - Interior)
                    </address>
                    <address>
                        E-mail geral: <a href="mailto:ugtsp@terra.com.br">ugtsp@terra.com.br</a><br/>
                        E-mail financeiro: <a href="mailto:financeiro@ugt-sp.org.br">financeiro@ugt-sp.org.br</a>
                    </address>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleHeader from '../index/components/title-header';
import axios from 'axios';

    export default {
        components: {
            TitleHeader,
        },
        data() {
            return {
                userContato: {
                    nome: '',
                    email: '',
                    mensagem: '',
                },
            };
        },
        methods: {
            submit() {
                axios.post('contato', this.userContato)
                .then(res => {
                    this.$swal({
                        title: 'Sucesso!',
                        text: 'Entraremos em contato em breve.',
                        icon: 'success',
                    })
                })
                .catch(error => {
                    this.$swal({
                        title: 'Sucesso!',
                        text: 'Entraremos em contato em breve.',
                        icon: 'success',
                    })
                })
            }
        }
    };
</script>

<style lang="scss" scoped>
.contact{
    @apply w-full;
    .content {
        @apply mx-auto mt-16 mb-24 w-full;
        max-width: 1280px;
        .formulario {
            form {
                @apply flex flex-col mx-auto justify-between items-end;
                width: 80%;
                input, textarea {
                    @apply mb-2 border-light-gray border-2 rounded-md py-3 px-5 w-full;
                }
                textarea {
                    @apply resize-none h-48;
                }
                button {
                    @apply bg-primary rounded-md py-2 text-white italic;
                    width: 120px;
                }
                button:hover {
                    background-color: #920002;
                }
                button:focus {
                    outline: none;
                }
            }
        }

        .info{
            @apply text-dark-gray;
            .logo {
                @apply mx-auto;
                max-width: 150px;
            }
            .informations {
                @apply text-center;
                p{
                    @apply my-5 text-xl;
                }
                address {
                    @apply my-5 not-italic text-xl;
                }
            }
        }

        @media(max-width: 767px) {
            @apply flex flex-col-reverse items-center justify-between;
            .info {
                @apply w-full border-b-2 border-light-gray mb-10 pb-5;
            }
            .formulario {
                @apply w-full px-10;
            }
        }
        @media(min-width: 768px) {
            @apply flex items-center justify-between;
            .formulario {
                @apply w-1/2 px-10;
            }
            .info {
                @apply w-1/2 border-l-2 border-light-gray;
            }
        }
    }
}
</style>

